"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.dateToString = void 0;
/**
 * Convert date to string with format 'MM/DD/YYYY'
 * @public
 *
 * @param date - A valid Date object
 *
 * @returns Date string with format 'MM/DD/YYYY'
 *
 * @example
 * ```ts
 * const parsedDate = dateToString(new Date('11/11/1986'))
 * console.log(newDate);
 * // -> '11/11/1986'
 * ```
 */
function fixValue(value) {
    const parsedValue = value.toString();
    return parsedValue.length === 1 ? `0${parsedValue}` : parsedValue;
}
function dateToString(date) {
    return `${fixValue(date.getMonth() + 1)}/${fixValue(date.getDate())}/${date.getFullYear()}`;
}
exports.dateToString = dateToString;
//# sourceMappingURL=date-to-string.js.map